<div class="container">
    <h1 class="page-title">Fund Type Overview</h1>
    <!--section-->
    <section class="widget">
        <div class="widget-body">
            <div class="mt">
                <!--form-->
                <form class="form-horizontal" [formGroup]="form" novalidate>
                    <div class="row form-group">
                        <label class="col-md-3"><strong>Fund Type Info:</strong></label>
                        <div class="col-md-8">
                            <!--Name-->
                            <div class="row form-field-spacing" [class.has-danger]="!name.valid && name.touched">
                                <span class="required-label col-md-3">Name</span>
                                <div class="col-md-8">
                                    <input [formControl]="name" class="form-control" type="text"
                                           formControlName="name"
                                           placeholder="Name">
                                </div>
                            </div>
                            <!--Regions-->
                            <div class="row form-field-spacing"
                                 [class.has-danger]="!regionValue.valid && regionValue.touched">
                                <span class="required-label col-md-3">Zone</span>
                                <div class="col-md-8">
                                    <select [formControl]="regionValue" class="form-select"
                                            formControlName="regionValue">
                                        <option value="null">Choose a zone</option>
                                        <option *ngFor="let region of allRegions" [value]="region.key">
                                            {{region.lookupValue}}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <!--Admin Region/Organization-->
                            <div class="row form-field-spacing">
                                <span class="required-label col-md-3">Has Administrative Agency</span>
                                <div class="col-md-3">
                                    <label class="form-check">
                                        <input class="form-check-input"
                                               id="selectManagementAgency"
                                               [formControl]="selectManagementAgencyControl"
                                               type="checkbox">
                                    </label>
                                </div>
                            </div>
                            <div *ngIf="showManagementAgency" class="row form-field-spacing"
                                 [class.has-danger]="managementAgencyId.errors?.['isRequired'] && managementAgencyId.touched">
                                <span class="required-label col-md-3">Administrative Agency</span>
                                <div class="col-md-8">
                                    <input #agency [formControl]="managementAgencyId"
                                           formControlName="managementAgencyId"
                                           type="text"
                                           class="form-control"
                                           (click)="managementAgencyListModal?.open()"
                                           value='All Agencies'
                                           placeholder="Administrative Region/Organization"
                                    >
                                </div>
                                <agency-box (onAgencySelected)="onManagementAgencyChange($event)"></agency-box>
                            </div>
                            <!--Fiscal Start Month-->
                            <div class="row form-field-spacing"
                                 [class.has-danger]="!fiscalStartMonth.valid && fiscalStartMonth.touched">
                                <span class="required-label col-md-3">Fiscal Start Month</span>
                                <div class="col-md-8">
                                    <select [formControl]="fiscalStartMonth" required
                                            class="form-select"
                                            type="text" formControlName="fiscalStartMonth">
                                        <option value="null">Fiscal Start Month</option>
                                        <option *ngFor="let month of months" [value]="month.value">{{month.key}}</option>
                                    </select>
                                </div>
                            </div>
                            <!--Fiscal Start Day-->
                            <div class="row form-field-spacing"
                                 [class.has-danger]="!fiscalStartDay.valid && fiscalStartDay.touched">
                                <span class="required-label col-md-3">Fiscal Start Day</span>
                                <div class="col-md-8">
                                    <select [formControl]="fiscalStartDay" required
                                            class="form-select" type="text"
                                            formControlName="fiscalStartDay">
                                        <option value="null">Fiscal Start Day</option>
                                        <option *ngFor="let day of days" [value]="day.value">{{day.value}}</option>
                                    </select>
                                </div>
                            </div>
                            <!--minimum Single Pledge Amt-->
                            <div class="row form-field-spacing"
                                 [class.has-danger]="!minSinglePledgeAmt.valid && minSinglePledgeAmt.touched">
                                <span class="required-label col-md-3">Min Single Pledge</span>
                                <div class="col-md-8">
                                    <input [formControl]="minSinglePledgeAmt" numbersOnly class="form-control"
                                           type="text"
                                           formControlName="minSinglePledgeAmt" placeholder="Minimum Single Pledge Amount">
                                </div>
                            </div>
                            <!--maximum Single Pledge Amt-->
                            <div class="row form-field-spacing"
                                 [class.has-danger]="!maxSinglePledgeAmt.valid && maxSinglePledgeAmt.touched">
                                <span class="required-label col-md-3">Max Single Pledge</span>
                                <div class="col-md-8">
                                    <input [formControl]="maxSinglePledgeAmt" numbersOnly class="form-control"
                                           type="text"
                                           formControlName="maxSinglePledgeAmt" placeholder="Maximum Single Pledge Amount">
                                </div>
                            </div>
                            <!--maximum Yearly Pledge Amt-->
                            <div class="row form-field-spacing"
                                 [class.has-danger]="!maxYearlyPledgeAmt.valid && maxYearlyPledgeAmt.touched">
                                <span class="required-label col-md-3">Max Yearly Pledge</span>
                                <div class="col-md-8">
                                    <input [formControl]="maxYearlyPledgeAmt" numbersOnly class="form-control"
                                           type="text"
                                           formControlName="maxYearlyPledgeAmt" placeholder="Maximum Yearly Pledge Amount">
                                </div>
                            </div>
                            <!--crisis Pledge Threshold-->
                            <div class="row form-field-spacing"
                                 [class.has-danger]="!crisisPledgeThreshold.valid && crisisPledgeThreshold.touched">
                                <span class="required-label col-md-3">Crisis Pledge Threshold</span>
                                <div class="col-md-8">
                                    <input [formControl]="crisisPledgeThreshold" numbersOnly class="form-control"
                                           type="text"
                                           formControlName="crisisPledgeThreshold"
                                           placeholder="Crisis Pledge Threshold Amount">
                                </div>
                            </div>
                            <!--ledger Number-->
                            <div class="row form-field-spacing"
                                 [class.has-danger]="!ledgerNumber.valid && ledgerNumber.touched">
                                <span *ngIf="ledgerNumber.touched && ledgerNumber.hasError('maxLength')"
                                      class="col-md-3"></span>
                                <div *ngIf="ledgerNumber.touched && ledgerNumber.hasError('maxLength')"
                                     class="form-control-feedback pledgeTypeError"> {{ledgerNumber.getError('maxLength')}}
                                </div>
                                <span class="required-label col-md-3">Ledger Number</span>
                                <div class="col-md-8">
                                    <input [formControl]="ledgerNumber" class="form-control" type="text"
                                           formControlName="ledgerNumber" placeholder="Ledger Number">
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--TYPE-->
                    <div class="row form-group">
                        <label class="col-md-3"><strong>Additional Options: </strong></label>
                        <div class="col-md-8">
                            <div [hidden]="isUwda.value || isEfs.value" class="row mb-2">
                                <span class="col-md-3 required-label">Program</span>
                                <div class="col-md-8">
                                    <select [formControl]="assistanceApplicationType"
                                            class="form-select" type="text"
                                            formControlName="assistanceApplicationType">
                                        <option [ngValue]="null">None</option>
                                        <option *ngFor="let program of programs" [value]="program.key">{{program.key}}</option>
                                    </select>
                                </div>
                            </div>

                            <!--is SSN Required-->
                            <div class="row" [class.has-danger]="!isSsnRequired.valid && isSsnRequired.touched">
                                <span class="required-label col-md-3">Is SSN Required</span>
                                <div class="col-md-3">
                                    <label class="form-check">
                                        <input [formControl]="isSsnRequired" class="form-check-input"
                                               type="checkbox"
                                               id="isSsnRequired">
                                    </label>
                                </div>
                            </div>
                            <!--is Active-->
                            <div *ngIf="currentSelectedPledgeType" class="row"
                                 [class.has-danger]="!isActive.valid && isActive.touched">
                                <span class="required-label col-md-3">Is Active</span>
                                <div class="col-md-3">
                                    <label class="form-check">
                                        <input [formControl]="isActive" class="form-check-input"
                                               type="checkbox"
                                               id="isActive">
                                    </label>
                                </div>
                            </div>
                            <!--is EFS-->
                            <div [hidden]="isUwda.value || assistanceApplicationType.value !== null || isPrivate.value" class="row"
                                 [class.has-danger]="!isEfs.valid && isEfs.touched">
                                <span class="required-label col-md-3">Is Efs</span>
                                <div class="col-md-3">
                                    <label class="form-check">
                                        <input [formControl]="isEfs" class="form-check-input"
                                               type="checkbox"
                                               id="isEfs">
                                    </label>
                                </div>
                            </div>

                            <!--efsStartDate-->
                            <div [hidden]="!isEfs.value" class="row form-field-spacing"
                                 [class.has-danger]="!efsStartDate.valid && efsStartDate.touched">
                                <span class="required-label col-md-3">EFS Start Date</span>
                                <input type="text" class="datePicker-padding col-md-8 form-control" bsDatepicker [formControl]="efsStartDate">
                            </div>
                            <!--efsEndDate-->
                            <div [hidden]="!isEfs.value" class="row form-field-spacing"
                                 [class.has-danger]="!efsEndDate.valid && efsEndDate.touched">
                                <span class="required-label col-md-3">EFS End Date</span>
                                <input type="text" class="datePicker-padding col-md-8 form-control" bsDatepicker [formControl]="efsEndDate">
                            </div>
                            <!--isUwda-->
                            <div [hidden]="isEfs.value || assistanceApplicationType.value !== null" class="row"
                                 [class.has-danger]="!isUwda.valid && isUwda.touched">
                                <span class="required-label col-md-3">Is UWDA</span>
                                <div class="col-md-3">
                                    <label class="form-check">
                                        <input [formControl]="isUwda" class="form-check-input"
                                               type="checkbox"
                                               id="isUwda">
                                    </label>
                                </div>
                            </div>
                            <!--is Private-->
                            <div [hidden]="isEfs.value" class="row"
                                 [class.has-danger]="!isPrivate.valid && isPrivate.touched">
                                <span class="required-label col-md-3">Is Private</span>
                                <div class="col-md-3">
                                    <label class="form-check">
                                        <input [formControl]="isPrivate" class="form-check-input"
                                               type="checkbox"
                                               id="isPrivate">
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row form-group" *ngIf="currentSelectedPledgeType?.id">
                        <label class="col-md-3">Mass Assign Fund Type:</label>
                        <div class="col-md-8">
                            <div class="row">
                                <span class="col-md-3">Associated Fund Type</span>
                                <massAssignPledgeType class="col-md-8"
                                                      [newPledgeTypeId]="currentSelectedPledgeType?.id"></massAssignPledgeType>
                            </div>
                        </div>
                    </div>
                    <!--submit-->
                    <div class="row form-group mt-4">
                        <div class="display-flex justify-content-end flex-row w-100">
                            <!--delete-->
                            <button type="button"
                                    *ngIf="!isNewPledge"
                                    class="btn btn-inverse me-4"
                                    (click)="showPromptModal()">Delete Fund Type
                            </button>
                            <!--save-->
                            <button [disable]="!form.dirty"
                                    type="submit"
                                    class="btn btn-primary me-2"
                                    [autoDisable]="submit">Save Fund Type
                            </button>
                            <cancel-button [route]="'/app/pledgetypes'"></cancel-button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <prompt-dialog #deletePromptModal
                [titleText]="'Delete Fund Type?'"
                [promptText]="'Are you sure you want to delete fund this type?'">
        </prompt-dialog>
        <prompt-dialog #deactivationPromptModal
                [titleText]="'Deactivate Fund Type'"
                [promptText]="'Deactivating this fund type will automatically remove it from any associated county public applications. Users will no longer be able to submit applications for those counties until a new fund type is assigned. Do you wish to continue?'">
        </prompt-dialog>
    </section>
</div>
